export default __webpack_public_path__ + "static/media/b1.64714c09.jpg";